module.exports = __webpack_public_path__ + "img/chair-2.12d4c569.svg";